var map = {
	"./app-store-badge.svg": "8e83",
	"./apple-icon.svg": "9d46",
	"./apple-white-icon.svg": "0ec2",
	"./atlassian-icon.svg": "fc70",
	"./atlassian-white-icon.svg": "9780",
	"./confluence.svg": "501d",
	"./google-icon.svg": "e0b4",
	"./google-play-badge.svg": "5806",
	"./google-white-icon.svg": "f542",
	"./jira.svg": "ebf7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b2f6";